export const ICON = {
  ADD: 'Add',
  ADJUSTMENTS: 'Adjustments',
  AI_EDIT: 'AiEdit',
  ALT_TEXT: 'AltText',
  ARROW: 'Arrow',
  ASCENDING: 'Ascending',
  BLUR: 'Blur',
  BOLD: 'Bold',
  CALENDAR: 'Calendar',
  CHEVRON: 'Chevron',
  CANCEL: 'Cancel',
  CASH_DOWN: 'CashDown',
  CENTER: 'Center',
  CHART: 'Chart',
  CHECK: 'Check',
  CLOCK: 'Clock',
  CLOSE: 'Close',
  COMMUNITY: 'Community',
  COPY: 'Copy',
  CROP: 'Crop',
  DELETE: 'Delete',
  DESCENDING: 'Descending',
  DISCOUNT: 'Discount',
  DOLLAR: 'Dollar',
  DOWNLOAD: 'Download',
  EDIT: 'Edit',
  ELLIPSIS: 'Ellipsis',
  ENHANCE: 'Enhance',
  ERASE: 'Erase',
  EXPORT: 'Export',
  EXTERNAL_LINK: 'ExternalLink',
  FAIL: 'Fail',
  FILTER: 'Filter',
  FOLDER: 'Folder',
  FORM: 'Form',
  GRIP: 'Grip',
  HAND_COINS: 'HandCoins',
  HELP: 'Help',
  IMAGE: 'Image',
  IMAGE_TO_VIDEO: 'ImageToVideo',
  IMPORT: 'Import',
  INFO: 'Info',
  ISOLATE: 'Isolate',
  ITALIC: 'Italic',
  LANDSCAPE: 'Landscape',
  LAYERS: 'Layers',
  LIGHT_BULB: 'LightBulb',
  LEFT: 'Left',
  LINE_TROUGH: 'LineThrough',
  LINK: 'Link',
  LIST: 'List',
  LOCK: 'Lock',
  LOGOUT: 'Logout',
  MAGIC_WAND: 'MagicWand',
  MAGIC_WAND_ANIMATION: 'MagicWandAnimation',
  MEGAPHONE: 'Megaphone',
  MERGE: 'Merge',
  MESSAGE: 'Message',
  MINUS: 'Minus',
  MORE_ANIMATION: 'MoreAnimation',
  MOVE_DOWN: 'MoveDown',
  MOVE_UP: 'MoveUp',
  OBJECT: 'Object',
  PAUSE: 'Pause',
  PERCENT: 'Percent',
  PLAY: 'Play',
  PLUS: 'Plus',
  PORTRAIT: 'Portrait',
  PRICE: 'Price',
  PROFILES: 'Profiles',
  PROMOTE: 'Promote',
  PUBLISH: 'Publish',
  REFRESH: 'Refresh',
  REMOVE_BACKGROUND: 'RemoveBackground',
  REPLACE: 'Replace',
  RIGHT: 'Right',
  ROCKET: 'Rocket',
  SCHEDULE: 'Schedule',
  SEARCH: 'Search',
  SETTINGS: 'Settings',
  SHARE: 'Share',
  SIDEBAR: 'Sidebar',
  SPARKLE: 'Sparkle',
  SPARKLES: 'Sparkles',
  SQUARE: 'Square',
  STAR: 'Star',
  SUCCESS: 'Success',
  SUPPORT: 'Support',
  TEXT: 'Text',
  TICKET_CHECK: 'TicketCheck',
  TOOLS: 'Tools',
  TRIAL: 'Trial',
  TRIANGLE_ALERT: 'TriangleAlert',
  UNLOCK: 'Unlock',
  UNDERLINE: 'Underline',
  UNDO: 'Undo',
  UPLOAD: 'Upload',
  UPGRADE: 'Upgrade',
  USER: 'User',
};
